import * as React from 'react'
import { iconRightM, iconLeftM } from 'images'

/**
 * @param {HeroNavProps} HeroNavProps - The component props.
 * @returns {JSX.Element} - The rendered component.
 */
const HeroNav = ({
  invertTextColor,
  activeItemIndex,
  totalItemCount,
  onNavigate
}) => {
  return (
    <div className={`hero-nav ${invertTextColor ? 'hero-nav--dark' : ''}`}>
      <button
        className="hero-nav__prev"
        onClick={() => onNavigate('prev')}
        tabIndex={0}
      >
        <img src={iconLeftM} alt="Hero Previous" />
      </button>
      <p className="hero-nav__display body">
        {activeItemIndex < 9 ? '0' : ''}
        {activeItemIndex + 1} / {totalItemCount < 10 ? '0' : ''}
        {totalItemCount}
      </p>
      <button
        className="hero-nav__next"
        tabIndex={0}
        onClick={() => onNavigate('next')}
      >
        <img src={iconRightM} alt="Hero Next" />
      </button>
    </div>
  )
}

export default HeroNav

/**
 * @typedef {{
 * invertTextColor: boolean,
 * activeItemIndex: number,
 * totalItemCount: number,
 * onNavigate: function
 * }} HeroNavProps
 */
